<div class="flex">

  <div class="h-screen flex-[7] flex flex-col justify-center items-center bg-slate-200">

    <div class="w-full flex px-8 items-center sm:justify-center md:space-x-16 pb-4 pt-24">

      <div class="flex flex-col space-y-2 ml-2">

        <p class="text-sm md:text-base truncate w-56 sm:w-64 md:w-72 lg:w-96">
          Comerciante:
          <span class="font-bold">{{info?.store_name}}</span>
        </p>

        <p class="text-sm lg:text-3xl">
          <span class="font-bold">{{ info?.amount | currency: '': '':'1.2-2' }}</span>
          <span> MZN </span>
        </p>

      </div>

      <div>
        <!-- <img
          *ngIf="info?.thumbnail_image != undefined"
          [src]="info?.thumbnail_image" alt="" class="w-28 h-28 rounded-full"> -->
        <qrcode
          [qrdata]="'Your data string'"
          colorLight="#E2E8F0"
        ></qrcode>
      </div>

    </div>
    <div class="space-y-5">

      <div
        class="w-screen max-w-[21rem] md:max-w-xl px-4 py-3 rounded-lg shadow-sm bg-white">
        <label class="block text-sm text-gray-400">Nome do produto</label>
        <p class="mt-1 text-base text-black font-semibold">{{info?.title}}</p>
      </div>

      <div
        *ngIf="info?.short_description != undefined"
        class="w-screen max-w-[21rem] md:max-w-xl px-4 py-3 rounded-lg shadow-sm bg-white">
        <label class="block text-sm text-gray-400">Nota</label>
        <p class="mt-1 text-base text-black font-semibold">{{info?.short_description}}</p>
      </div>

    </div>

    <div class="grid grid-cols-2 gap-6 py-20">
      <button
        *ngFor="let pservic of paymentServs; let i = index"
        class="flex justify-center items-center"
        [routerLink]="['/payment', pservic.name]"
      >
        <img
          class="w-44 h-16 object-contain rounded-full"
          [src]="pservic.logo"
          [alt]="pservic.name"
          [ngStyle]="{'background-color': pservic.color}"
        >
      </button>
    </div>

    <div class="text-center pb-20">
      <p class="text-gray-400">Ao realizar um pagamento, concorda com os nossos</p>
      <a
        href="https://imali.co.mz/politicas-de-privacidade/"
        target="_blank"
        class="no-underline"
        [ngStyle]="{'color': customPurple}"
      >Termos de Serviço Gerais</a>
    </div>

  </div>

  <!-- In Small Screen I want this div to be disabled -->
  <div class="flex-[3] bg-slate-200 hidden lg:block">
    <div
      class="flex flex-col justify-evenly items-center h-screen rounded-s-[2rem]"
      [ngStyle]="{'background-color': customPurple}"
    >
      <div>
        <img src="assets/images/imali_logo_white.png" alt="imali_logo" class="w-20">
        <p class="text-white py-10">Aproveita o teu dinheiro da melhor forma.</p>
        <a href="https://imali.co.mz/" target="_blank" class="text-white underline">Saber Mais</a>
      </div>

      <div class="relative">

        <img src="assets/images/tv.png" alt="tv" class="h-44">

        <img src="assets/images/lightbulb.png" alt="lightbulb"
             class="h-52 absolute bottom-0 left-0 translate-x-[-44%] translate-y-[30%]">
      </div>
    </div>
  </div>
</div>
